module.exports = __webpack_public_path__ + "img/multimedia.2bdcda1a.png";